export default "__VITE_ASSET__BabESgXX__"